import type { ReactNode } from "react";

import { StyledTemplateLabel, StyledViewHeader } from "./styles";

type Props = {
    /** Already translated — the styled label appends the trailing colon itself. */
    text: ReactNode;
    children: ReactNode;
    insightView?: ReactNode;
};

/** The one section header naming a signal family, shared by every signal type's filters view. */
const SignalFiltersViewHeader = ({ text, children, insightView = null }: Props) => {
    return (
        <StyledViewHeader>
            <StyledTemplateLabel text={text}>{children}</StyledTemplateLabel>

            {insightView}
        </StyledViewHeader>
    );
};

export default SignalFiltersViewHeader;
